import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { BarsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const BarsList = Loader(lazy(() => import('../../content/pages/Bars/BarsList')));
const BarsDetail = Loader(lazy(() => import('../../content/pages/Bars/BarsDetail')));
const CreateBar = Loader(lazy(() => import('../../content/pages/Bars/BarCreate')));
const BarUpdate = Loader(lazy(() => import('../../content/pages/Bars/BarUpdate')));

export const createBarsRoutes = () => ({
  path: 'bars',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['venueViewAll', 'venueViewAllClient', 'venueViewAllVenue']} should404>
          <Navigate to="/bars/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['venueViewAll', 'venueViewAllClient', 'venueViewAllVenue']} should404>
          <BarsProvider>
            <BarsList />
          </BarsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: ':barId/',
      element: (
        <PermissionsGuard allowedPermissions={['venueView']} should404>
          <BarsProvider>
            <BarsDetail />
          </BarsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:barId/update`,
      element: (
        <PermissionsGuard allowedPermissions={['venueEntityUpdate']} should404>
          <BarsProvider>
            <BarUpdate />
          </BarsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['venueEntityCreate']} should404>
          <BarsProvider>
            <CreateBar />
          </BarsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
